import axiosX from "./axiosX";

import { readAppSetting } from '../libs/appSettingUtils';
const appSetting = readAppSetting();

/**
 * 获取报告列表
 * @param orgId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export const getReportList = (orgId, params, onSuccess, onFail) => {
  axiosX.post(`${appSetting.khlis}testReport/list`, params,
    (result) => {
        if (!result.success) {
          onFail(new Error(result.errorMsg));
          return;
        }
        if ($.isFunction(onSuccess)) {
          onSuccess(result.data.items)
        }
      },
      onFail
  );
}

/**
 * 获取pdf（base64）
 * @param orgId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export const getPdfs = (orgId, params, onSuccess, onFail)=>{
  axiosX.get(`${appSetting.khlis}testReport/pdf/${orgId}`,
    params,
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess(result.tag);//pdf 的 base64 是通过tag返回
      }
    }, onFail
  );
}

/**
 * 更新打印次数
 * @param orgId
 * @param params
 * @param onSuccess
 * @param onFail
 */
export const updatePrintCount = (orgId, params, onSuccess, onFail)=>{
  axiosX.get(`${appSetting.khlis}testReport/updatePrintNum/${orgId}`,
    params,
    (result) => {
      if (!result.success) {
        onFail(new Error(result.errorMsg));
        return;
      }
      if ($.isFunction(onSuccess)) {
        onSuccess();
      }
    }, onFail
  );
}

export default {
  getReportList,
  getPdfs,
  updatePrintCount
}



// WEBPACK FOOTER //
// ./src/api/apiReport.js